import type * as Stitches from '@stitches/react'

import { uiBaseColorsLight } from '../../lib/stitches/ui.colors'
import { Beacon } from './beacon'
import { Caret } from './caret'
import { Checkmark } from './checkmark'
import { Chevron } from './chevron'
import { Close } from './close'
import { Compass } from './compass'
import { Copy } from './copy'
import { Document } from './document'
import { GitBranch } from './git-branch'
import { Grafbase } from './grafbase'
import { GraphQL } from './graphql'
import { StyledIcon } from './icon.styles'
import { InsertNewOperation } from './insert-new-operation'
import { Interpunct } from './interpunct'
import { LockClosed } from './lock-closed'
import { Plus } from './plus'
import { Prettier } from './prettier'
import { Retry } from './retry'
import { Sort } from './sort'
import { SplitToTabs } from './split-to-tabs'
import { Stop } from './stop'

export const IconMap = {
  Beacon,
  Caret,
  Checkmark,
  Chevron,
  Close,
  Compass,
  Copy,
  Document,
  GitBranch,
  Grafbase,
  GraphQL,
  Interpunct,
  InsertNewOperation,
  LockClosed,
  Plus,
  Prettier,
  Retry,
  SplitToTabs,
  Sort,
  Stop
}

export type IconNames = keyof typeof IconMap

export type IconProps = {
  color?: keyof typeof uiBaseColorsLight
  // color?: Stitches.VariantProps<typeof StyledIcon>['color']
  name: IconNames
  rotate?: '90' | '180' | '270'
  size?: Stitches.VariantProps<typeof StyledIcon>['size']
}
